/**
 * @desc 油卡明细列表分页
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.OilCardDetailedQuery>): Promise<BaseResponse<defs.PageBean<Array<defs.CardPetrolDepositObject>>>> {
  return fetch({
    url: config.API_HOST + '/elecCard/vehicle/cardDepositListPage',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
